<template>
    <div>
      <base-header class="mt-4 pb-6" type=""></base-header>
      <b-container fluid class="mt--6">
        <div>
          <loading :active="loadingCounter > 0" color= '#007bff' :width= '128' :height= '128' loader='dots' :can-cancel="true" is-full-page/>
        </div>
        <b-row>
          <b-col lg="12">
            <div class="card-wrapper">
              <card>
                <div slot="header" class="mb-0">
                  <b-row>
                    <b-col>
                        <h3>{{language_terms['PERIOD_LOCKING']}}</h3>
                    </b-col>
                  </b-row>
                </div>
                <b-row>
                  <b-col md="3">
                    <base-input label="AR">
                      <flat-picker slot-scope="{focus, blur}"
                                  @on-open="focus"
                                  @on-close="blur"
                                  style="background-color: white;"
                                  class="form-control datepicker"
                                  v-model="data.ar_locked_date">
                      </flat-picker>
                    </base-input>
                  </b-col>
                  <b-col md="3">
                    <base-input label="AP">
                      <flat-picker slot-scope="{focus, blur}"
                                  @on-open="focus"
                                  @on-close="blur"
                                  style="background-color: white;"
                                  class="form-control datepicker"
                                  v-model="data.ap_locked_date">
                      </flat-picker>
                    </base-input>
                  </b-col>
                  <b-col md="3">
                    <base-input label="GL">
                      <flat-picker slot-scope="{focus, blur}"
                                  @on-open="focus"
                                  @on-close="blur"
                                  style="background-color: white;"
                                  class="form-control datepicker"
                                  v-model="data.gl_locked_date">
                      </flat-picker>
                    </base-input>
                  </b-col>
                  <b-col md="3" class="mt-4">
                    <base-button type="primary" @click="onClickSave" class="mt-2"><i class="fa fa-save"></i></base-button>
                  </b-col>
                </b-row>
              </card>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </div>
  </template>
  <style>
  th.VueTables__sortable {color:rgb(255,255,255);}
  td.VueTables__row  {color:black}
  .v-data-table /deep/ .sticky-header {position: sticky; top: var(--toolbarHeight);}
  .v-data-table /deep/ .v-data-table__wrapper {overflow: unset;}
  </style>
  <style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
  
  <script>
  import moment from 'moment'
  import { Select, Option } from 'element-ui'
  import flatPicker from "vue-flatpickr-component";
  import "flatpickr/dist/flatpickr.css";
  import Loading from 'vue-loading-overlay';
  import 'vue-loading-overlay/dist/vue-loading.css';  
  import { mapState } from "vuex";
  import PaginatedTables from '@/views/Tables/PaginatedTables'
  import axios from "axios";
  import { apiRoutes } from "../../apiRoutes";
  import { authHeader } from "../../global";
  import Vue from 'vue'
  
  export default {
    components:{
      Loading,
      [Select.name]: Select,
      [Option.name]: Option,
      flatPicker,
      PaginatedTables
    },
    computed:{
        ...mapState({
          language_terms: state => state.languages.language_terms,
          selected_lang: state => state.languages.selected_langauge,
        }),
    },
    async mounted()
    {
        this.loadingCounter++
        this.loadDefaults();
        this.loadingCounter--      
    },    
    data(){
      return{
        loadingCounter:0,
        data:[],
        account_tags:[],
        selectedReceipt:[],
        reportOptions:{perPage:10000, perPageValues:[],stickyHeader:true, stickyHeaderColor:'#ffffff', stickyHeaderBackground:'#292F4C', hiddenColumns:[],filterable:false},
        report:{headers:[], rows:[]},
        rowDetailsModal:false,
        fullPage:true,
        filter:{
          account:[],
          account_tag: [],
          date_from: new Date(),
          date_to: new Date(),
        },
      }
    },
  
    methods:{
        onSelectAccount() 
        {
            this.filter.account_tag = null

            for (var index = 0; index < this.accounts.length; index++) {
                var item = this.accounts[index];
                if (item.code == this.filter.account)
                {
                    if (item.is_taggable)
                        this.account_tags = item.tags
                    else
                    {
                        this.account_tags = []
                    }
                        
                }
            }
            
        },

      limitText(count)
      {
          return `and ${count} others`;
      },
      async loadDefaults(query) 
      {
        let payload = {};
        await axios.post(apiRoutes["ACCOUNTS_RETRIEVE_LOCKED_DATES"], payload, authHeader()).then((response) => {
            if (response.data.code == 1) {
              this.data = response.data.data;
            }
          })
          .catch((error) => {
            if (error.response) {
              Vue.notify({group: "notify", type: "error", text: error.response.data.msg, max: 5, duration: 5000, speed: 300,});          
          }
          });
      },
  
        async onClickSave()
        {
            let payload = {data:this.data};
            await axios.post(apiRoutes["ACCOUNTS_UPDATE_LOCKED_DATES"], payload, authHeader()).then((response) => {
                if (response.data.code == 1) {
                this.data = response.data.data;
                alert('Period has been locked');
                }
            })
            .catch((error) => {
                if (error.response) {
                Vue.notify({group: "notify", type: "error", text: error.response.data.msg, max: 5, duration: 5000, speed: 300,});          
            }
            });
            },
    }
  }
  </script>
    